import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

interface DestinationListPropsTypes {
  items: { name: string; url: string }[];
}

const DestinationList: FC<DestinationListPropsTypes> = props => {
  const { items } = props;

  return (
    <Row>
      {items?.map((item, index) => (
        <Col key={index} xs={12} sm={6} md={4} className="my-2">
          <Link to={item.url} className="btn btn-secondary btn-block white-card-button w-100 py-4">
            <h5 className="text-center m-0">{item.name}</h5>
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default DestinationList;
